import React from "react";

// Filet de sécurité global : toute erreur de rendu React (ex: une donnée
// inattendue venue de l'agent conversationnel) ne doit JAMAIS produire une page
// blanche pour l'utilisateur. Au lieu de ça on affiche un écran propre + un
// bouton « recharger », et on montre la vraie erreur (repliée) pour le diagnostic.
// Ajouté 2026-05-31 après un testeur tombé sur une page blanche en cliquant
// « Modifier mes critères ».
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Trace console (visible dans les outils dev / remontée éventuelle).
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] crash de rendu:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const isEN = typeof navigator !== "undefined" && /^en/i.test(navigator.language || "");
    const wrap = {
      minHeight: "100vh", background: "#07111F", color: "#E8DCC8",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "24px 18px",
      fontFamily: "Lato, system-ui, sans-serif", textAlign: "center",
    };
    const card = {
      maxWidth: 460, background: "#091929", border: "1px solid #C9A84C55",
      borderRadius: 18, padding: "28px 24px", boxShadow: "0 24px 48px rgba(0,0,0,0.5)",
    };
    const btn = {
      width: "100%", padding: "13px", borderRadius: 12, border: "none",
      background: "#C9A84C", color: "#07111F", fontWeight: 800, fontSize: 15,
      cursor: "pointer", marginTop: 14,
    };

    return (
      <div style={wrap}>
        <div style={card}>
          <div style={{ fontSize: 38, marginBottom: 8 }}>⚓</div>
          <div style={{ fontSize: 19, fontWeight: 700, marginBottom: 10 }}>
            {isEN ? "Something went sideways" : "Un petit pépin est survenu"}
          </div>
          <div style={{ fontSize: 14.5, color: "#9AB8D0", lineHeight: 1.6, marginBottom: 6 }}>
            {isEN
              ? "Sorry about that. Reload to get back on track — your last search is safe."
              : "Désolé pour ça. Rechargez pour repartir du bon pied — votre dernière recherche est en sécurité."}
          </div>
          <button style={btn} onClick={() => window.location.reload()}>
            {isEN ? "Reload" : "Recharger"}
          </button>
          <button
            style={{ ...btn, background: "transparent", border: "1px solid #2A4A66", color: "#7A9BB5", fontWeight: 600 }}
            onClick={() => { window.location.href = "/"; }}
          >
            {isEN ? "Back to home" : "Retour à l'accueil"}
          </button>
          {this.state.error?.message && (
            <details style={{ marginTop: 16, textAlign: "left" }}>
              <summary style={{ cursor: "pointer", fontSize: 12, color: "#5A7A95" }}>
                {isEN ? "Technical detail" : "Détail technique"}
              </summary>
              <pre style={{
                marginTop: 8, fontSize: 11, color: "#7A9BB5", whiteSpace: "pre-wrap",
                wordBreak: "break-word", background: "#06111E", padding: 10, borderRadius: 8,
              }}>{String(this.state.error.message)}</pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
